import { type Facility } from '@reliance/types/models/Facility';
import { type ApiService } from '../types/ApiService';

export const website = (centralApi: ApiService) => ({
  getBaseData: (hostname: string) =>
    centralApi.get<Facility>('/facility/by-site-url/' + hostname),
});
